import * as THREE from 'three';

/**
 * This is a temporary workaround.
 * Follow the topic at https://github.com/mrdoob/three.js/issues/18334 for the actual implementation.
 */
const _box$3 = /*@__PURE__*/ new THREE.Box3();
/**
 * This is a temporary workaround.
 * Follow the topic at https://github.com/mrdoob/three.js/issues/18334 for the actual implementation.
 */
THREE.Box3.prototype.expandByObject = function(object:any ){

    // Computes the world-axis-aligned bounding box of an object (including its children),
    // accounting for both the object's, and children's, world transforms

    object.updateWorldMatrix( false, false );

    const geometry = object.geometry;

    if ( geometry !== undefined ) {

        if (!geometry.boundingBox) {

            geometry.computeBoundingBox();

        }

        _box$3.copy( geometry.boundingBox );
        if(object.isInstancedMesh === true){
            for (let index = 0; index < object.count; index++) {
                _box$3.copy( geometry.boundingBox );
                let m4 = new THREE.Matrix4();
                object.getMatrixAt(index, m4);
                _box$3.applyMatrix4(m4);
                this.union( _box$3 );
            }
        }
        else{
            _box$3.applyMatrix4( object.matrixWorld );
            this.union( _box$3 );
        }
    }

    const children = object.children;

    for ( let i = 0, l = children.length; i < l; i ++ ) {

        this.expandByObject( children[ i ] );

    }

    return this;
}